import { useState, useEffect, useCallback } from 'react'
import { fetchAssistTrackerByTeam } from '../../Api/Teams/teams.api'
import { AppError, normalizeError } from '../../Utils'
import { logEvent } from '../../Utils'
import { calculateTotalAssists } from '../../Utils/Teams'
import type { UseAssistTrackerProps, UseAssistTrackerReturn } from './types'

// ASSIST_TRACKER_START_WEEK: 5
const ASSISTS_BEFORE_TRACKER_START = 19

export const useAssistTracker = ({
  teamId,
  year,
}: UseAssistTrackerProps): UseAssistTrackerReturn => {
  const [totalAssists, setTotalAssists] = useState(0)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<AppError | null>(null)

  useEffect(() => {
    if (teamId) {
      fetchAssistData()
    }
  }, [teamId])

  const handleError = useCallback((error: unknown, context: string) => {
    const normalizedError = normalizeError(error)
    console.error(`Error in ${context}:`, normalizedError)
    setError(normalizedError)
    logEvent('assist_tracker_error', {
      context,
      error_message: normalizedError.message,
    })
  }, [])

  const fetchAssistData = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const data = await fetchAssistTrackerByTeam(teamId, year)
      if (data) {
        const calculatedAssists =
          calculateTotalAssists(teamId, data) - ASSISTS_BEFORE_TRACKER_START
        //TODO: Hardcoded because of tracking only from WK 5, need to fix this later
        setTotalAssists(calculatedAssists)
      }
      setIsLoading(false)
    } catch (err) {
      handleError(err, 'fetchAssistData')
      setIsLoading(false)
    }
  }, [teamId, year, handleError])

  return {
    totalAssists,
    isLoading,
    error,
  }
}
